import React from 'react'
import { useIsOnboardingActive } from '../../../store/onboarding/useIsOnboardingActive'

interface OnboardingGateProps {
  children: React.ReactNode
}

export const OnboardingGate: React.FC<OnboardingGateProps> = ({ children }) => {
  const { isActive } = useIsOnboardingActive()
  if (!isActive) {
    return null
  }
  return <>{children}</>
}
